export { HrAsAServicePage } from './HrAsAServicePage';
